import React, {CSSProperties, FC} from 'react'
import {LinkPathResult, LINK_DASH_PATTERNS} from '../../services/widgetLinkService'

interface Props {
    linkPathResult: LinkPathResult
    isSelected: boolean
    onClick: (linkId: string, ctrlKey: boolean) => void
}

export const WidgetLinkPath: FC<Props> = ({linkPathResult, isSelected, onClick}) => {

    const pathClick = (event: React.MouseEvent<SVGPathElement>) => {
        onClick(linkPathResult.id, event.ctrlKey)
    }
    const dashArray = LINK_DASH_PATTERNS[linkPathResult.lineStyle]
    const linkStyles: CSSProperties = linkPathResult.color ? {
        stroke: linkPathResult.color,
        markerEnd: 'url(#arrow' + linkPathResult.color.substring(1) + ')'
    }: {

    }
    if (dashArray) {
        linkStyles.strokeDasharray = dashArray
        linkStyles.strokeLinecap = 'round'
    }

    return (<React.Fragment>
            <path
                d={linkPathResult.path}
                className="linkHitArea"
                onClick={pathClick}
            />
            <path
                d={linkPathResult.path}
                className={isSelected ? "linkPathSelected" : "linkPath"}
                style={linkStyles}
            />
        </React.Fragment>
    )
}
